/* @flow */

// item should have an id property
const prepareForNullify = (item: { id: string }) => ({ id: item.id, _nullify: true });

export default prepareForNullify;
